import { render } from "./FormInfo.vue?vue&type=template&id=dcde24c0&scoped=true"
import script from "./FormInfo.vue?vue&type=script&lang=js"
export * from "./FormInfo.vue?vue&type=script&lang=js"

import "./FormInfo.vue?vue&type=style&index=0&id=dcde24c0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcde24c0"]])

export default __exports__